module.exports = __webpack_public_path__ + "img/Anschnallen.fd4212e6.jpg";